import { ApprovalStatusType } from './../../model/constant';
import { BookingStatusType } from 'app/model/constant';
import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { Subscription } from 'rxjs/Rx';
import { UtilitiesService } from '../../services/utilities/utilities.service';
import { MyBookingDataSctionType as SECTION_TYPE, BookerInfoSection } from './booking-detail-section';
import { PaymentChannelType, Language, OfferType, PaymentType } from '../../model/constant';
import { TranslatePipe } from 'app/pipes/translate.pipe';
import { AppConfigService } from 'app/services/app-config/app-config.service';
import { TranslateSingularPluralPipe } from 'app/pipes/translate-singular-plural.pipe';

@Component({
  selector: 'act-booking-detail',
  templateUrl: './booking-detail.component.html',
  styleUrls: ['./booking-detail.component.scss']
})
export class BookingDetailComponent implements OnInit, OnChanges {

  @Input() myBooking: any;
  @Input() type: SECTION_TYPE;
  @Input() lang: string;
  @Input() prefixElementId: string;

  public dataType = SECTION_TYPE;
  public paymentChannelType = PaymentChannelType;
  public offerType = OfferType;
  public isMobile = false;
  public isShareBudget = false;
  public paymentType = PaymentType;
  public approvalStatusType = ApprovalStatusType;
  public isShareBudgetByAdmin = false;
  public showMoreRoomInfo = [];
  public showMoreBookerInfo = [];
  public showMoreCoBookerInfo = [];

  public dataSelenium: any = {};
  private formatDateFromApi = 'D MMM YYYY HH:mm:ss';
  private formatDateSelenium = 'YYYY-MM-DD';

  subscriptionLanguage: Subscription;

  constructor(
    private utilService: UtilitiesService,
    private translate: TranslatePipe,
    private appConfigService: AppConfigService,
    private translatePlural: TranslateSingularPluralPipe,
  ) {
    this.isMobile = this.utilService.isMobile();
  }

  ngOnInit() { }

  ngOnChanges(changes: SimpleChanges) {
    if (changes && changes.myBooking && changes.myBooking.currentValue) {
      this.initialData();
    }
  }

  private initialData() {
    switch (this.type) {
      case SECTION_TYPE.BOOKING:
        this.prepareBookingSection();
        break;
      case SECTION_TYPE.ROOM:
        this.prepareRoomDetailSection();
        break;
      case SECTION_TYPE.BOOKING_DETAIL:
        this.prepareBookingDetailSection();
        break;
    }
  }

  private prepareBookingSection() {
    if (this.isMobile) {
      this.myBooking.checkIn['date'] = this.lang === Language.th ? this.utilService.convertDateFormat(this.myBooking.checkIn['date'], null, 'dd D MMM YY') :
        this.utilService.convertDateFormat(this.myBooking.checkIn['date'], null, 'dd D MMM YY');
      this.myBooking.checkOut['date'] = this.lang === Language.th ? this.utilService.convertDateFormat(this.myBooking.checkOut['date'], null, 'dd D MMM YY') :
        this.utilService.convertDateFormat(this.myBooking.checkOut['date'], null, 'dd D MMM YY');
    } else {
      this.myBooking.checkIn['date'] = this.utilService.convertDateFormat(this.myBooking.checkIn['date'], null, 'ddd D MMMM YYYY');
      this.myBooking.checkOut['date'] = this.utilService.convertDateFormat(this.myBooking.checkOut['date'], null, 'ddd D MMMM YYYY');
    }
    this.dataSelenium.checkInDate = this.utilService.convertDateFormat(
      this.myBooking.checkIn['date'], this.formatDateFromApi, this.formatDateSelenium, Language.en);
    this.dataSelenium.checkOutDate = this.utilService.convertDateFormat(
      this.myBooking.checkOut['date'], this.formatDateFromApi, this.formatDateSelenium, Language.en);
  }

  private prepareRoomDetailSection() {
    this.myBooking.forEach(room => {
      if (room.freeCancellationDate) {
        room.freeCancellationDate = this.utilService.convertDateFormat(room.freeCancellationDate, null, 'D MMM YY');
      }
      if (room.showcancellationPolicies && room.cancellationPolicies && room.cancellationPolicies.length > 0) {
        room.policyMessage = [];
        room.cancellationPolicies.forEach(cancelPolicy => {
          room.policyMessage.push(this.translate
            .transform('booking-detail-cancellation-policy-charge')
            .replace('{date}', this.utilService.convertDateFormat(cancelPolicy.fromDate, null, 'D MMM YY'))
            .replace('{currencycode}', room.currencyCode)
            .replace('{cancelFee}', this.utilService.insertCurrencySymbol(cancelPolicy.cancelFee)));
        });
      }
    });
  }

  private prepareBookingDetailSection() {
    if (this.isMobile) {
      this.myBooking.checkIn['date'] = this.lang === Language.th ? this.utilService.convertDateFormat(this.myBooking.checkIn['date'], null, 'do MMM YY') :
        this.utilService.convertDateFormat(this.myBooking.checkIn['date'], null, 'DD MMM YY');
      this.myBooking.checkOut['date'] = this.lang === Language.th ? this.utilService.convertDateFormat(this.myBooking.checkOut['date'], null, 'do MMM YY') :
        this.utilService.convertDateFormat(this.myBooking.checkOut['date'], null, 'DD MMM YY');
    } else {
      this.myBooking.checkIn['date'] = this.utilService.convertDateFormat(this.myBooking.checkIn['date'], null, 'ddd D MMMM YYYY');
      this.myBooking.checkOut['date'] = this.utilService.convertDateFormat(this.myBooking.checkOut['date'], null, 'ddd D MMMM YYYY');
    }
    this.dataSelenium.checkInDate = this.utilService.convertDateFormat(
      this.myBooking.checkIn['date'], this.formatDateFromApi, this.formatDateSelenium, Language.en);
    this.dataSelenium.checkOutDate = this.utilService.convertDateFormat(
      this.myBooking.checkOut['date'], this.formatDateFromApi, this.formatDateSelenium, Language.en);

    if (this.myBooking.bookingStatus) {
      this.myBooking.bookingStatus.payOnDate = this.myBooking.bookingStatus.payOnDate ?
        this.utilService.convertDateFormat(this.myBooking.bookingStatus.payOnDate, null, 'D MMM YY') : undefined;
      this.myBooking.bookingStatus.cancellationDate = this.myBooking.bookingStatus.cancellationDate ?
        this.utilService.convertDateFormat(this.myBooking.bookingStatus.cancellationDate, null, 'D MMM YY') : undefined;
      this.myBooking.bookingStatus.approvalDate = this.myBooking.bookingStatus.approvalDate ?
        this.utilService.convertDateFormat(this.myBooking.bookingStatus.approvalDate, null, 'D MMM YY') : undefined;
    }
    this.isShareBudgetByAdmin = this.shareBudgetByAdmin();
    this.prepareRoomGuestAmount();
  }

  private prepareRoomGuestAmount() {
    const occupancyInfo = this.myBooking.occupancyInfo;
    let bookingDetailAdultText = this.appConfigService.getLanguage() === Language.th ? this.translate.transform('booking-detail-details-adult-text') + ' ' : '';
    let bookingDetailChildText = this.appConfigService.getLanguage() === Language.th ? this.translate.transform('booking-detail-details-child-text') + ' ' : '';
    let roomGuestAmount = bookingDetailAdultText + occupancyInfo.adult + ' ' + this.translatePlural.transform('booking-detail-details-adult', occupancyInfo.adult);
    if (occupancyInfo.child && occupancyInfo.child > 0) {
      roomGuestAmount += ', ' + bookingDetailChildText + occupancyInfo.child + ' ' + this.translatePlural.transform('booking-detail-details-child', occupancyInfo.child);
    }
    if (occupancyInfo.childrenAge && occupancyInfo.childrenAge.length > 0) {
      let and = this.translate.transform('booking-detail-details-and');
      let childrenAgeTextTemplate = this.translate.transform('booking-detail-details-children-age');
      const formattedChildrenAge = occupancyInfo.childrenAge.length === 1
            ? occupancyInfo.childrenAge[0].toString()
            : `${occupancyInfo.childrenAge.slice(0, -1).join(', ')} ${and} ${occupancyInfo.childrenAge.slice(-1)[0]}`;
      const childrenAgeText = childrenAgeTextTemplate.replace('{age}', formattedChildrenAge);
      roomGuestAmount += ' ' + childrenAgeText;
    }
    this.dataSelenium.roomGuestAmount = roomGuestAmount;
  }

  public filterMainBooker(bookersInfo: BookerInfoSection[], isMain = true) {
    this.isShareBudget = bookersInfo.length > 1;
    if (bookersInfo.length > 0 && bookersInfo.length <= 2) {
      return bookersInfo.filter(booker => booker.mainBooker === isMain);
    }
    return isMain ? bookersInfo.filter(booker => booker.mainBooker) : bookersInfo.filter(booker => !booker.mainBooker)[0];
  }

  shareBudgetByAdmin() {
    return this.myBooking.bookingStatus.paymentType === PaymentType.SHARE_BUDGET_BY_ADMIN || this.myBooking.bookingStatus.paymentType === PaymentType.SHARE_BUDGET_BY_ADMIN_MULTI_PAYMENT;
  }

  toggleCollapseInfo(section: string, index: number) {
    if (this[section].includes(index)) {
      this[section] = this[section].filter(x => x !== index);
    } else {
      this[section].push(index);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/components/booking-detail/booking-detail.component.ts